(() => {
  const builders = document.querySelectorAll('[data-l2c-accessories-builder]');
  if (!builders.length) return;

  builders.forEach((builder) => {
    if (builder.dataset.ready === 'true') return;
    builder.dataset.ready = 'true';

    const readJson = (selector, fallback) => {
      const node = builder.querySelector(selector);
      if (!node) return fallback;
      try {
        return JSON.parse(node.textContent || '');
      } catch (error) {
        return fallback;
      }
    };

    const products = readJson('[data-accessory-products]', []).filter((item) => item && item.variants && item.variants.length);
    const copy = {
      soldOut: 'Sold out',
      selected: 'Selected',
      viewImage: 'View image',
      adding: 'Adding accessory to cart...',
      added: 'Added. Opening your cart...',
      unable: 'Unable to add this accessory to cart.',
      selectFirst: 'Please choose an accessory option first.',
      ...readJson('[data-accessory-copy]', {})
    };

    const typeWrap = builder.querySelector('[data-accessory-types]');
    const variantWrap = builder.querySelector('[data-accessory-variants]');
    const image = builder.querySelector('[data-accessory-image]');
    const thumbs = builder.querySelector('[data-accessory-thumbs]');
    const prev = builder.querySelector('[data-accessory-prev]');
    const next = builder.querySelector('[data-accessory-next]');
    const title = builder.querySelector('[data-accessory-title]');
    const description = builder.querySelector('[data-accessory-description]');
    const details = builder.querySelector('[data-accessory-details]');
    const variantInput = builder.querySelector('[data-accessory-variant-id]');
    const quantityInput = builder.querySelector('[data-accessory-quantity]');
    const price = builder.querySelector('[data-accessory-price]');
    const form = builder.querySelector('[data-accessory-form]');
    const submit = builder.querySelector('[data-accessory-submit]');
    const status = builder.querySelector('[data-accessory-status]');

    const state = {
      productIndex: 0,
      variantId: '',
      mediaIndex: 0
    };

    const normalizeId = (value) => String(value || '').replace('gid://shopify/ProductVariant/', '');
    const currentProduct = () => products[state.productIndex] || products[0];
    const currentVariant = () => {
      const product = currentProduct();
      return product?.variants.find((variant) => String(variant.id) === String(state.variantId)) || product?.variants[0];
    };

    const setStatus = (message) => {
      if (status) status.textContent = message || '';
    };

    const mediaSet = () => {
      const variant = currentVariant();
      if (variant?.images?.length) return variant.images;
      if (variant?.image) return [{ src: variant.image, thumb: variant.thumb, alt: variant.alt || variant.title }];
      const product = currentProduct();
      if (product?.image) return [{ src: product.image, thumb: product.thumb, alt: product.alt || product.title }];
      return [];
    };

    const renderMedia = () => {
      const images = mediaSet();
      if (state.mediaIndex >= images.length) state.mediaIndex = 0;
      const active = images[state.mediaIndex] || images[0];
      if (image && active?.src) {
        image.src = active.src;
        image.alt = active.alt || '';
      }

      if (thumbs) {
        thumbs.innerHTML = '';
        images.forEach((item, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'l2c-accessories__thumb';
          button.setAttribute('aria-label', `${copy.viewImage} ${index + 1}`);
          button.setAttribute('aria-pressed', index === state.mediaIndex ? 'true' : 'false');
          button.innerHTML = item.thumb ? `<img src="${item.thumb}" alt="${item.alt || `${copy.viewImage} ${index + 1}`}">` : '';
          button.addEventListener('click', () => {
            state.mediaIndex = index;
            renderMedia();
          });
          thumbs.appendChild(button);
        });
        thumbs.hidden = images.length < 2;
      }

      if (prev) {
        prev.hidden = images.length < 2;
        prev.disabled = images.length < 2;
      }
      if (next) {
        next.hidden = images.length < 2;
        next.disabled = images.length < 2;
      }
    };

    const renderTypes = () => {
      if (!typeWrap) return;
      typeWrap.innerHTML = '';
      products.forEach((product, index) => {
        const sample = product.variants.find((variant) => variant.available) || product.variants[0];
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'l2c-accessories__type';
        button.setAttribute('aria-pressed', index === state.productIndex ? 'true' : 'false');
        button.innerHTML = `
          ${sample?.thumb ? `<img src="${sample.thumb}" alt="${sample.alt || sample.title || product.title}">` : ''}
          <span><strong>${product.title}</strong><small>${product.summary || product.description || ''}</small></span>
        `;
        button.addEventListener('click', () => {
          state.productIndex = index;
          state.variantId = String(sample?.id || '');
          state.mediaIndex = 0;
          setStatus('');
          render();
        });
        typeWrap.appendChild(button);
      });
    };

    const renderVariants = () => {
      if (!variantWrap) return;
      const product = currentProduct();
      variantWrap.innerHTML = '';
      product?.variants.forEach((variant) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'l2c-accessories__variant';
        button.disabled = !variant.available;
        button.setAttribute('aria-pressed', String(variant.id) === String(state.variantId) ? 'true' : 'false');
        button.innerHTML = `
          ${variant.thumb ? `<img src="${variant.thumb}" alt="${variant.alt || variant.title}">` : ''}
          <span><strong>${variant.title}</strong><small>${variant.available ? variant.price : copy.soldOut}</small></span>
        `;
        button.addEventListener('click', () => {
          state.variantId = String(variant.id);
          state.mediaIndex = 0;
          setStatus('');
          render();
        });
        variantWrap.appendChild(button);
      });
    };

    const renderSummary = () => {
      const product = currentProduct();
      const variant = currentVariant();
      if (title) title.textContent = product?.title || '';
      if (description) description.textContent = product?.summary || product?.description || '';
      if (details) details.innerHTML = product?.detailsHtml || product?.description || '';
      if (variantInput) variantInput.value = variant?.id || '';
      if (price) price.textContent = variant?.price || '';
      if (submit) submit.disabled = !variant?.available;
    };

    const render = () => {
      renderTypes();
      renderVariants();
      renderSummary();
      renderMedia();
    };

    const changeMedia = (direction) => {
      const images = mediaSet();
      if (images.length < 2) return;
      state.mediaIndex = (state.mediaIndex + direction + images.length) % images.length;
      renderMedia();
    };

    prev?.addEventListener('click', () => changeMedia(-1));
    next?.addEventListener('click', () => changeMedia(1));

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const variant = currentVariant();
      if (!variant?.id) {
        setStatus(copy.selectFirst);
        return;
      }

      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      submit.disabled = true;
      setStatus(copy.adding);

      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sections = Array.from(cartItemsComponents)
        .map((item) => item instanceof HTMLElement ? item.dataset.sectionId : '')
        .filter(Boolean);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(normalizeId(variant.id)),
            quantity,
            sections
          })
        });
        if (!response.ok) throw new Error('Add to cart failed');
        setStatus(copy.added);
        document.dispatchEvent(new CustomEvent('cart:update'));
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          window.location.href = '/cart';
        }
      } catch (error) {
        submit.disabled = false;
        setStatus(copy.unable);
      }
    });

    if (products.length) {
      const firstProduct = currentProduct();
      const firstVariant = firstProduct.variants.find((variant) => variant.available) || firstProduct.variants[0];
      state.variantId = String(firstVariant?.id || '');
      render();
    }
  });
})();
